import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import LottieAnimation from '../LottieAnimation/LottieAnimation'
import { MaterialIcon } from '@dsny/dsny-component-library'
import { useTheme } from 'styled-components'
import {
  CloseButton,
  QueueItemTitle,
  QueueItemArtist,
  QueueItemContainer,
  Row
} from './Queue.styles'

const QueueItem = ({
  item,
  title,
  artist,
  isReleaseItem = false,
  isPlaying,
  showPlayingIcon,
  onClickClose,
  onClickPlay,
  isHighlighted
}) => {
  const theme = useTheme()

  const onClose = useCallback((e) => {
    e.stopPropagation()
    onClickClose?.()
  }, [])

  return (
    <QueueItemContainer onClick={onClickPlay}>
      <Row>
        {isHighlighted && isPlaying && (
          <LottieAnimation
            width={16}
            height={16}
            style={{ marginRight: 4, display: 'inline-flex', marginLeft: 0 }}
          />
        )}
        <QueueItemTitle
          isPlaying={isPlaying}
          isHighlighted={isHighlighted}
          className="truncate"
        >
          {title}
        </QueueItemTitle>

        <CloseButton type="button" onClick={onClose}>
          <MaterialIcon
            name="X"
            style={{ width: 12, height: 12 }}
            color={theme.colors.neutralW70}
          />
        </CloseButton>
      </Row>

      <Row>
        <QueueItemArtist className="truncate">{artist}</QueueItemArtist>
      </Row>
    </QueueItemContainer>
  )
}

QueueItem.propTypes = {
  item: PropTypes.object,
  title: PropTypes.string,
  artist: PropTypes.string,
  tracksCount: PropTypes.number,
  isReleaseItem: PropTypes.bool,
  isOpen: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  isPlaying: PropTypes.bool,
  showPlayingIcon: PropTypes.bool,
  onClickCollapseBtn: PropTypes.func,
  onClickClose: PropTypes.func,
  onClickPlay: PropTypes.func
}

export default QueueItem
